export default __webpack_public_path__ + "static/cta-plants-2-1174892ce64c9fd6d48455b63e115586.jpg";